import { JumpNav, StickyStackItem, Tab, useJumpNavConfig } from '@uplift/ui-v2';
import { makeStyles, withStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';

export const enum DashboardTabEnum {
  todaysSessions = 'todaysSession',
  toDos = 'toDos',
  payments = 'payments',
}


const StyledTab = withStyles(Tab, theme => ({
  root: {
    borderBottom: 'none',
    fontWeight: 700
  },
  selected: {
    color: theme.palette.secondary.main
  },
}));


const useStyles = makeStyles()(theme => ({
  container: {
    background: theme.palette.common.white,
    color: theme.palette.darkSlate.main,
    zIndex: theme.zIndex.appBar - 1,
    width: '100%',
    '& a': {
      flex: 1
    },
    boxShadow: '0px 4px 2px -2px rgba(0, 0, 0, 0.2), 0px 6px 4px -4px rgba(0, 0, 0, 0.14), 0px 8px 6px -6px rgba(0, 0, 0, 0.12)'
  },
}));


export const DashboardJumpNav: React.FC = () => {
  const { navValue } = useJumpNavConfig({ initialNavValue: DashboardTabEnum.payments, sectionIds: [ DashboardTabEnum.todaysSessions, DashboardTabEnum.toDos, DashboardTabEnum.payments ] });
  const l10n = useL10n();
  const { classes } = useStyles();

  const tabs = [
    { label: l10n.dashboard.tabs.today, value: DashboardTabEnum.todaysSessions },
    { label: l10n.dashboard.tabs.toDo, value: DashboardTabEnum.toDos },
    { label: l10n.dashboard.tabs.payments, value: DashboardTabEnum.payments },
  ];

  return (
    <StickyStackItem placement="top" order={1}>
      <div className={classes.container}>
        <JumpNav value={navValue} textColor="secondary" indicatorColor="secondary" variant="fullWidth">
          {tabs.map((tab) => (
            <StyledTab
              key={tab.value}
              jump
              label={tab.label}
              value={tab.value}
              headerOffset={142}
            />
          ))}
        </JumpNav>
      </div>
    </StickyStackItem>
  );
};
